// add or remove placements in the blacklist or the whitelist
export const CHANGE_BLACKLIST_PLACEMENTS = 'change_blacklist_placements'
export const CHANGE_WHITELIST_PLACEMENTS = 'change_whitelist_placements'
// change ads status at the ads and the action log ads pages
export const CHANGE_ADS_STATUS = 'change_ads_status'
// change keywords status at the keywords and the action log keywords pages
export const CHANGE_KEYWORDS_STATUS = 'change_keywords_status'
// change profile settings
export const CHANGE_SETTINGS = 'change_settings'

// usually user authorities
export const USER_AUTHORITIES = [
  CHANGE_BLACKLIST_PLACEMENTS,
  CHANGE_WHITELIST_PLACEMENTS,
  CHANGE_ADS_STATUS,
  CHANGE_KEYWORDS_STATUS,
  CHANGE_SETTINGS
]

// service admin authorities
export const ADMIN_AUTHORITIES = []

export function hasAuthorities(_allowAuthorities = [], _userAuthorities = []) {
  const allowAuthorities = Array.isArray(_allowAuthorities) ? _allowAuthorities : [_allowAuthorities]
  const userAuthorities = Array.isArray(_userAuthorities) ? _userAuthorities : [_userAuthorities]
  if (allowAuthorities.length === 0) return true
  if (userAuthorities.length === 0) return false

  const isAllowed = userAuthorities.some(authority => allowAuthorities.includes(authority))
  return isAllowed
}
